<style src="./DistributorNew.scss" lang="scss" scoped></style>
<template lang="html">
  <section class="permission">
    ok

  </section>
</template>

<script>
export default {
  name: 'DistributorNew'
}
</script>


// WEBPACK FOOTER //
// src/view/record/distributor/components/new/DistributorNew.vue